module.exports = __webpack_public_path__ + "img/10@2x.3e6efa1e.png";